import { SEO } from '../../components';
import {
  Header,
  Footer,
  HeroSection,
  FinalCTASection,
} from '../../components/sections';
import {
  UiUxDesignProcessSection,
  UiUxBlogPromoSection,
  UiUxCollaborationSection,
} from '../../components/sections/services';
import { getCanonicalUrl, buildHreflangTags } from '../../lib/siteUrl';

export default function UiUxSuunnitteluPage() {
  return (
    <>
      <SEO
        title="UI/UX suunnittelu | Identio"
        description="UX-suunnittelulla sitoutuneita käyttäjiä ja korkean tason digitaalisia kokemuksia. Kokonaisvaltaista design-osaamista käyttäjätutkimuksesta UI-suunnitteluun."
        url={getCanonicalUrl('/palvelut/ui-ux-suunnittelu')}
        alternates={buildHreflangTags('/palvelut/ui-ux-suunnittelu', '/services/ui-ux-design')}
      />
      <Header />
      <main id="main-content" tabIndex={-1}>
        <HeroSection variant="uiUxDesign" />
        <UiUxDesignProcessSection />
        <UiUxBlogPromoSection />
        <UiUxCollaborationSection />
        <FinalCTASection
          variant="withForm"
          showContactSidebar={true}
          title="Tarvitsetko UI/UX-osaamista?"
          subtitle="Keskustellaan siitä, miten käyttäjätutkimus, wireframet ja käyttöliittymäsuunnittelu voivat parantaa tuotettanne ja käyttökokemusta."
        />
      </main>
      <Footer />
    </>
  );
}
